import { useState } from 'react';
import { useKnowledgeHub } from '../hooks/use-knowledge-hub.hooks';
import styles from './components.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { ROUTES } from 'shared/constants';
import { createSearchParams, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import classnames from 'classnames';
import { Input } from 'antd';
const { Search } = Input;

export function HubSearch({ variant = 'default' }) {
  const lang = useSelector(getLang('KNOWLEDGE_HUB'));
  const { organizationId, organizationsList } = useKnowledgeHub();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const searchParam = searchParams.get('q');
  const [searchValue, setSearchValue] = useState(searchParam || '');

  const executeSearch = value => {
    if (!value || !value.trim()) {
      if (location.pathname.includes(ROUTES.KNOWLEDGE_HUB_SEARCH)) {
        navigate(ROUTES.KNOWLEDGE_HUB);
      }
      return;
    }
    navigate({
      pathname: ROUTES.KNOWLEDGE_HUB_SEARCH,
      search: createSearchParams({ q: value }).toString(),
    });
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      executeSearch(searchValue);
    }
  };

  // Always enable search when an organization is selected
  const hasOrganizations = organizationId || organizationsList.length > 0;
  const isSearchPage = location.pathname.includes(ROUTES.KNOWLEDGE_HUB_SEARCH);

  // For default variant, only show when no org is selected and not on search page
  // For header variant, show when an org is selected OR on search page
  if (variant === 'default' && (organizationId || isSearchPage)) return null;
  if (variant === 'header' && !organizationId && !isSearchPage) return null;

  return (
    <Search
      className={classnames(styles.searchBox, { [styles.headerSearchBox]: variant === 'header' })}
      placeholder={lang.SEARCH_PLACEHOLDER}
      value={searchValue}
      onChange={e => setSearchValue(e.target.value)}
      onKeyDown={handleKeyDown}
      onSearch={executeSearch}
      autoFocus={location.pathname.includes(ROUTES.KNOWLEDGE_HUB_SEARCH) || searchParam}
      allowClear
      disabled={!hasOrganizations}
    />
  );
}
